import { InjectionToken, Provider, Type } from '@angular/core';
import {AiRealtimeAppEvent} from "../../api/service/aiRealtime.service";

export interface AiAppEventRendererComponent {
    event: AiRealtimeAppEvent;
}

export const AI_APP_EVENT_RENDERERS =
    new InjectionToken<Type<AiAppEventRendererComponent>[]>('AI_APP_EVENT_RENDERERS');

export function provideAiAppEventRenderer(
    component: Type<AiAppEventRendererComponent> & { eventName: string }
): Provider {
    return {
        provide: AI_APP_EVENT_RENDERERS,
        useValue: component,
        multi: true,
    };
}